import { upload } from "@vercel/blob/client";
import { authFetch } from "../../HttpClient";

// Appels à l'API du manuel de procédures (backend-myalfa, /api/procedures).
const BASE = "https://backend-myalfa.vercel.app/api/procedures";

async function appel(url, options) {
  const res = await authFetch(url, {
    ...options,
    headers: { "Content-Type": "application/json", ...(options && options.headers) },
  });
  if (!res.ok) {
    let message = `Erreur ${res.status}`;
    try {
      message = (await res.json()).message || message;
    } catch (e) {
      // corps non JSON : on garde le statut
    }
    throw new Error(message);
  }
  return res.json();
}

const corps = (b) => JSON.stringify(b);

export const chargerProcedures = () => appel(BASE);
export const chargerVersionsApi = (id) => appel(`${BASE}/pages/${id}/versions`);
export const creerPageApi = (b) => appel(`${BASE}/pages`, { method: "POST", body: corps(b) });
export const enregistrerPageApi = (id, b) => appel(`${BASE}/pages/${id}`, { method: "PUT", body: corps(b) });
export const restaurerVersionApi = (id, v) => appel(`${BASE}/pages/${id}/restauration`, { method: "POST", body: corps({ v }) });
export const changerStatutApi = (id, status) => appel(`${BASE}/pages/${id}/statut`, { method: "PUT", body: corps({ status }) });
export const corbeilleApi = (id, on) => appel(`${BASE}/pages/${id}/corbeille`, { method: "POST", body: corps({ on }) });
export const dupliquerPageApi = (id) => appel(`${BASE}/pages/${id}/duplication`, { method: "POST" });
export const basculerFavoriApi = (id) => appel(`${BASE}/pages/${id}/favori`, { method: "POST" });
export const partagerPageApi = (id, b) => appel(`${BASE}/pages/${id}/partage`, { method: "POST", body: corps(b) });
export const modifierAclApi =(b) => appel(`${BASE}/acl`, { method: "PUT", body: corps(b) });
export const creerSectionApi = (espaceId, name) => appel(`${BASE}/espaces/${espaceId}/sections`, { method: "POST", body: corps({ name }) });

/* ---------- Rédaction par l'IA ---------- */

// Fichier joint envoyé directement du navigateur vers Vercel Blob.
const nomBlob = (nom) =>
  String(nom || "document")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Za-z0-9._-]+/g, "-")
    .replace(/^-+|-+$/g, "") || "document";
export const televerserFichierIa = (fichier, nom) =>
  upload(`procedures-ia/${nomBlob(nom)}`, fichier, {
    access: "public",
    handleUploadUrl: `${BASE}/ia/upload-token`,
    clientPayload: localStorage.getItem("token"),
  });
export const supprimerFichiersIaApi = (urls) =>
  appel(`${BASE}/ia/fichiers/suppression`, { method: "POST", body: corps({ urls }) });

// Le brouillon arrive au fur et à mesure : une ligne JSON par événement
// (etape, texte, reprise, attente, fin, erreur), transmise à onEvenement.
export async function redigerIaApi(body, onEvenement, signal) {
  const res = await authFetch(`${BASE}/ia/redaction`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: corps(body),
    signal,
  });
  if (!res.ok) {
    let message = `Erreur ${res.status}`;
    try {
      message = (await res.json()).message || message;
    } catch (e) {
      // corps non JSON : on garde le statut
    }
    throw new Error(message);
  }
  const lecteur = res.body.getReader();
  const decodeur = new TextDecoder();
  let tampon = "";
  const lignes = (fin) => {
    let i;
    while ((i = tampon.indexOf("\n")) >= 0) {
      const l = tampon.slice(0, i).trim();
      tampon = tampon.slice(i + 1);
      if (l) onEvenement(JSON.parse(l));
    }
    if (fin && tampon.trim()) onEvenement(JSON.parse(tampon));
  };
  for (;;) {
    const { value, done } = await lecteur.read();
    if (done) break;
    tampon += decodeur.decode(value, { stream: true });
    lignes(false);
  }
  lignes(true);
}
